import { z } from 'zod';
import { ACTIVITY_TYPE_VALUES, CALL_OUTCOME_VALUES, TASK_PRIORITY_VALUES, } from '../constants/activityTypes.js';
const linkSchema = z
    .object({
    project_id: z.string().uuid(),
    lead_id: z.string().uuid().optional().nullable(),
    deal_id: z.string().uuid().optional().nullable(),
    account_id: z.string().uuid().optional().nullable(),
})
    .refine((v) => v.lead_id || v.deal_id || v.account_id, {
    message: 'Koppel aan lead, deal of account',
});
export const activityCreateSchema = linkSchema.extend({
    activity_type: z.enum(ACTIVITY_TYPE_VALUES),
    title: z.string().max(500).optional().nullable(),
    body: z.string().max(20000).optional().nullable(),
    due_at: z.string().datetime().optional().nullable(),
    priority: z.enum(TASK_PRIORITY_VALUES).optional(),
    assignee_user_id: z.string().uuid().optional().nullable(),
    pinned: z.boolean().optional(),
    internal_only: z.boolean().optional(),
    call_outcome: z.enum(CALL_OUTCOME_VALUES).optional().nullable(),
    duration_minutes: z.coerce.number().int().min(0).max(1440).optional().nullable(),
});
export const activityUpdateSchema = z.object({
    title: z.string().max(500).optional().nullable(),
    body: z.string().max(20000).optional().nullable(),
    due_at: z.string().datetime().optional().nullable(),
    priority: z.enum(TASK_PRIORITY_VALUES).optional(),
    status: z.enum(['open', 'done', 'cancelled']).optional(),
    assignee_user_id: z.string().uuid().optional().nullable(),
    pinned: z.boolean().optional(),
    internal_only: z.boolean().optional(),
    snoozed_until: z.string().datetime().optional().nullable(),
    call_outcome: z.enum(CALL_OUTCOME_VALUES).optional().nullable(),
    duration_minutes: z.coerce.number().int().min(0).max(1440).optional().nullable(),
});
export const timelineQuerySchema = z.object({
    project_id: z.string().uuid(),
    lead_id: z.string().uuid().optional(),
    deal_id: z.string().uuid().optional(),
    account_id: z.string().uuid().optional(),
    types: z.string().max(200).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(80),
});
export const myTasksQuerySchema = z.object({
    project_id: z.string().uuid().optional(),
});
//# sourceMappingURL=activity.js.map